<!--  -->
<template>
  <div id="footer">
    <div class="footer-bottom">
      <div class="box7">
        <p>
          <img
            src="../assets/eduDefault/icon.png"
          />备案号：吉ICP备20000186号-1&nbsp;联系我们：0431-80606821&nbsp;技术支持：卓越科技
        </p>
        <p>
          Copyright&nbsp;©&nbsp;2018-{{ newYear }}. All Rights
          Reserved.&nbsp;长春新区管理委员会&nbsp;版权所有
        </p>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      newYear: new Date().getFullYear(),
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //方法集合
  methods: {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
/*@import url(); 引入公共css类*/
#footer {
  width: 100%;
  height: auto;
  background-image: linear-gradient(180deg, #2a76e6 0%, #5ab6ff 100%);
}

.link .ul4 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  line-height: 42px;
}

#footer .footer-bottom {
  width: 100%;
  height: 108.8px;
  background: #fff;
}

#footer .footer-bottom .box7 {
  color: #5f6464;
  font-size: 16px;
  position: relative;
  top: 24.4px;
  letter-spacing: 0.5px;
}

#footer .footer-bottom .box7 p {
  line-height: 30px;
  text-align: center;
}

#footer .footer-bottom .box7 p:nth-child(3) {
  margin-left: -9px;
}

#footer .footer-bottom .box7 img {
  width: 20px;
  height: 20px;
  position: relative;
  left: 0px;
  top: 3px;
  margin-right: 5px;
}
</style>